import React, { useState } from "react";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";

import $ from "jquery";

const Detail = () => {
  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Planningsperiode in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Planningsperiode
          </a>
        </div>
        <div className="float-right mt-0">
          <a id="edit-button" className="button bewerken">
            Bewerken
          </a>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam</div>
            <div className="box-title-2-active" id="d-algemeen-naam" />
            <span
              className="tooltiptext detail"
              id="naam-tooltip"
              id="d-algemeen-naam-tooltip"
            ></span>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code</div>
            <div className="box-title-2" id="d-algemeen-code" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Omschrijving</div>
            <div className="box-title-2" id="d-algemeen-omschrijving" />
            <span
              className="tooltiptext detail"
              id="naam-tooltip"
              id="d-algemeen-omschrijving-tooltip"
            ></span>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Flexibel inplannen</div>
            <label className="switch">
              <input id="d-algemeen-inplannen" type="checkbox" disabled />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Actief</div>
            <label className="switch">
              <input id="d-algemeen-actief" type="checkbox" disabled />
              <span className="slider-checkbox round" />
            </label>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-sm-6">
          <div className="inp-labl">Start datum</div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <img src={dateTimePng} width={30} height={28} />
              </span>
            </div>
            <input
              type="text"
              className="form-control inp-h inpp"
              id="d-algemeen-start-datum"
              disabled
              placeholder=""
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="inp-labl">Eind datum</div>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <img src={dateTimePng} width={30} height={28} />
              </span>
            </div>
            <input
              type="text"
              className="form-control inp-h inpp"
              id="d-algemeen-eind-datum"
              disabled
              placeholder=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
